import { useContext } from 'react'

import { SupportAssistantContext } from './support-assistant.context'
import { SupportContextValue } from './support-assistant.types'

export const useSupportAssistant = (): SupportContextValue => {
  const ctx = useContext(SupportAssistantContext)
  if (!ctx) {
    throw new Error('useSupportAssistant must be used within a SupportAssistantProvider')
  }
  return ctx
}
